import { hideAppLoaderAction, showAppLoaderAction } from "./appLoaderActionCreator";

export function showAppLoader(dispatch: (arg0: { type: string; displayAppLoader: boolean }) => void) {
    dispatch(showAppLoaderAction());
}

export function hideAppLoader(dispatch: (arg0: { type: string; displayAppLoader: boolean }) => void) {
    dispatch(hideAppLoaderAction());
}